import loginReducer from './login/reducer';
import userReducer from './user/reducer';
import constantsCodesReducer from './constantsCodes/reducer';
import providerReducer from './provider/reducer';
import locationReducer from './location/reducer';
import notificationsReducer from './notifications/reducer';
import ordersGridReducer from './ordersGrid/reducer';
import orderDetailReducer from './orderDetail/reducer';
import ordersImportReducer from './ordersImport/reducer';
import ordersUpdateReducer from './ordersUpdate/reducer';
import claimsUpdateReducer from './claimsUpdate/reducer';
import productsUpdateReducer from './productsUpdate/reducer';
import productsListReducer from './productsList/reducer';
import productsGridReducer from './productsGrid/reducer';
import productDetailReducer from './productDetail/reducer';
import productsImportReducer from './productsImport/reducer';
import productSetsListReducer from './productSetsList/reducer';
import productSetDetailReducer from './productSetDetail/reducer';
import billsOfMaterialListReducer from './billsOfMaterialsList/reducer';
import billOfMaterialsDetailReducer from './billOfMaterialsDetail/reducer';
import alertMessagesReducer from './alertMessages/reducer';
import applicationInstallReducer from './applicationInstall/reducer';
import integrationReducer from './integration/reducer';
import rolesListReducer from './rolesList/reducer';
import roleDetailReducer from './roleDetail/reducer';
import permissionsListReducer from './permissionsList/reducer';
import permissionDetailReducer from './permissionDetail/reducer';
import usersListReducer from './usersList/reducer';
import userDetailReducer from './userDetail/reducer';
import rolesApprovedReducer from './rolesApproved/reducer';
import providersListReducer from './providersList/reducer';
import providerDetailReducer from './providerDetail/reducer';
import providerConfigDetailReducer from './providerConfigDetail/reducer';
import systemConfigDetailReducer from './systemConfigDetail/reducer';
import userNotificationsDetailReducer from './userNotificationsDetail/reducer';
import myNotificationsReducer from './myNotifications/reducer';
import userPermissionsDetailReducer from './userPermissionsDetail/reducer';
import claimsGridReducer from './claimsGrid/reducer';
import claimsImportReducer from './claimsImport/reducer';
import claimDetailReducer from './claimDetail/reducer';
import returnsGridReducer from './returnsGrid/reducer';
import returnDetailReducer from './returnDetail/reducer';
import returnsUpdateReducer from './returnsUpdate/reducer';
import receivingsGridReducer from './receivingsGrid/reducer';
import receivingsUpdateReducer from './receivingsUpdate/reducer';
import receivingDetailReducer from './receivingDetail/reducer';
import userSettingsReducer from './userSettings/reducer';
import zasilkovnaReducer from './zasilkovna/reducer';
import providerCompaniesListReducer from './providerCompaniesList/reducer';
import providerTransferCompaniesListReducer from './providerTransferCompaniesList/reducer';
import providerCompanyDetailReducer from './providerCompanyDetail/reducer';
import providerTransferCompanyDetailReducer from './providerTransferCompanyDetail/reducer';
import orderExpeditionPackagesGridReducer from './orderExpeditionPackagesGrid/reducer';
import orderExpeditionPackageDetailReducer from './orderExpeditionPackageDetail/reducer';
import orderMessagesOnExpeditionBoxGridReducer from './orderMessagesOnExpeditionBoxGrid/reducer';
import orderMessagesOnExpeditionBoxDetailReducer from './orderMessagesOnExpeditionBoxDetail/reducer';
import transportsListReducer from './transportsList/reducer';
import transportDetailReducer from './transportDetail/reducer';
import balikovnaReducer from './balikovna/reducer';
import dpdPlacesReducer from './dpdPlaces/reducer';
import tasksGridReducer from './tasksGrid/reducer';
import overviewOrdersGridReducer from './overviewOrdersGrid/reducer';
import overviewIntervalReducer from './overviewInterval/reducer';
import storageReducer from './storage/reducer';
import pplPlacesReducer from './pplPlaces/reducer';
import dhlServicePointsReducer from './dhlServicePoints/reducer';
import glsSkPlacesReducer from './glsskPlaces/reducer';
import productCompletionSheetsListReducer from './productCompletionSheetsList/reducer';
import productCompletionSheetDetailReducer from './productCompletionSheetDetail/reducer';
import productStockTransfersDetailReducer from './productStockTransfersDetail/reducer';
import skladonMappingListReducer from './skladonMappingList/reducer';
import skladonMappingDetailReducer from './skladonMappingDetail/reducer';
import remindersListReducer from './remindersList/reducer';
import reminderDetailReducer from './reminderDetail/reducer';
import resetPasswordReducer from './resetPassword/reducer';
import applicationStatusMessagesListReducer from './applicationStatusMessagesList/reducer';
import applicationStatusMessageDetailReducer from './applicationStatusMessageDetail/reducer';
import emailTemplatesListReducer from './emailTemplates/reducer';
import emailTemplatesDetailReducer from './emailTemplateDetail/reducer';
import carriersListReducer from './carriersList/reducer';
import carrierDetailReducer from './carrierDetail/reducer';
import egonRoutesListReducer from './egonRoutesList/reducer';
import egonRouteDetailReducer from './egonRouteDetail/reducer';
import egonDeliveriesReducer from './egonDeliveries/reducer';
import transportPackageTypesListReducer from './transportPackageTypesList/reducer';
import transportPackageTypeDetailReducer from './transportPackageTypeDetail/reducer';
import webhooksListReducer from './webhooksList/reducer';
import webhookDetailReducer from './webhookDetail/reducer';
import webhookDeliveriesGridReducer from './webhookDeliveriesGrid/reducer';
import webhookDeliveryDetailReducer from './webhookDeliveryDetail/reducer';
import webhookHistoryReducer from './webhookHistory/reducer';

const rootReducer = {
    login: loginReducer,
    user: userReducer,
    constantsCodes: constantsCodesReducer,
    provider: providerReducer,
    location: locationReducer,
    notifications: notificationsReducer,
    ordersGrid: ordersGridReducer,
    orderDetail: orderDetailReducer,
    ordersImport: ordersImportReducer,
    ordersUpdate: ordersUpdateReducer,
    productsList: productsListReducer,
    productsGrid: productsGridReducer,
    productDetail: productDetailReducer,
    productsImport: productsImportReducer,
    productSetsList: productSetsListReducer,
    productSetDetail: productSetDetailReducer,
    billsOfMaterialList: billsOfMaterialListReducer,
    billOfMaterialsDetail: billOfMaterialsDetailReducer,
    alertMessages: alertMessagesReducer,
    rolesList: rolesListReducer,
    roleDetail: roleDetailReducer,
    permissionsList: permissionsListReducer,
    permissionDetail: permissionDetailReducer,
    usersList: usersListReducer,
    userDetail: userDetailReducer,
    rolesApproved: rolesApprovedReducer,
    providersList: providersListReducer,
    providerDetail: providerDetailReducer,
    providerConfigDetail: providerConfigDetailReducer,
    systemConfigDetail: systemConfigDetailReducer,
    userNotificationsDetail: userNotificationsDetailReducer,
    myNotifications: myNotificationsReducer,
    userPermissionsDetail: userPermissionsDetailReducer,
    claimsGrid: claimsGridReducer,
    claimsImport: claimsImportReducer,
    claimDetail: claimDetailReducer,
    returnsGrid: returnsGridReducer,
    returnDetail: returnDetailReducer,
    returnsUpdate: returnsUpdateReducer,
    receivingsGrid: receivingsGridReducer,
    receivingsUpdate: receivingsUpdateReducer,
    receivingDetail: receivingDetailReducer,
    userSettings: userSettingsReducer,
    zasilkovna: zasilkovnaReducer,
    providerCompaniesList: providerCompaniesListReducer,
    providerCompanyDetail: providerCompanyDetailReducer,
    providerTransferCompaniesList: providerTransferCompaniesListReducer,
    providerTransferCompanyDetail: providerTransferCompanyDetailReducer,
    orderExpeditionPackagesGrid: orderExpeditionPackagesGridReducer,
    orderExpeditionPackageDetail: orderExpeditionPackageDetailReducer,
    orderMessagesOnExpeditionBoxGrid: orderMessagesOnExpeditionBoxGridReducer,
    orderMessagesOnExpeditionBoxDetail: orderMessagesOnExpeditionBoxDetailReducer,
    transportsList: transportsListReducer,
    transportDetail: transportDetailReducer,
    balikovna: balikovnaReducer,
    dpdPlaces: dpdPlacesReducer,
    tasksGrid: tasksGridReducer,
    overviewOrdersGrid: overviewOrdersGridReducer,
    overviewInterval: overviewIntervalReducer,
    storage: storageReducer,
    pplPlaces: pplPlacesReducer,
    dhlServicePoints: dhlServicePointsReducer,
    glsSkPlaces: glsSkPlacesReducer,
    productCompletionSheetsList: productCompletionSheetsListReducer,
    productCompletionSheetDetail: productCompletionSheetDetailReducer,
    productStockTransfersDetail: productStockTransfersDetailReducer,
    skladonMappingList: skladonMappingListReducer,
    skladonMappingDetail: skladonMappingDetailReducer,
    remindersList: remindersListReducer,
    reminderDetail: reminderDetailReducer,
    resetPassword: resetPasswordReducer,
    applicationStatusMessagesList: applicationStatusMessagesListReducer,
    applicationStatusMessageDetail: applicationStatusMessageDetailReducer,
    emailTemplatesList: emailTemplatesListReducer,
    emailTemplateDetail: emailTemplatesDetailReducer,
    carriersList: carriersListReducer,
    carrierDetail: carrierDetailReducer,
    egonRoutesList: egonRoutesListReducer,
    egonRouteDetail: egonRouteDetailReducer,
    egonDeliveries: egonDeliveriesReducer,
    transportPackageTypesList: transportPackageTypesListReducer,
    transportPackageTypeDetail: transportPackageTypeDetailReducer,
    webhooksList: webhooksListReducer,
    webhookDetail: webhookDetailReducer,
    webhookDeliveriesGrid: webhookDeliveriesGridReducer,
    webhookDeliveryDetail: webhookDeliveryDetailReducer,
    webhookHistory: webhookHistoryReducer,
    claimsUpdate: claimsUpdateReducer,
    productsUpdate: productsUpdateReducer,
    applicationInstall: applicationInstallReducer,
    integrationDetail: integrationReducer,
};

export default rootReducer;
